import { Vue } from 'vue-property-decorator';

export default class PesticideNavigator extends Vue {
}